import OrganisationList from "../features/organisation-management/components/OrganisationList";

const OrganisationScreen = () => {
    return <OrganisationList />
}

OrganisationScreen.guestGuard = false;
OrganisationScreen.authGuard = true;

export { OrganisationScreen }
export default OrganisationScreen;